import styled, { css } from 'styled-components';
import Colors from '@/v2/constants/Colors';

interface ContainerProps {
  selected?: boolean;
  disabled?: boolean;
  variant?: 'vertical' | 'horizontal';
  size?: 'default' | 'compact';
}

export const Container = styled.div<ContainerProps>`
  position: relative;
  display: flex;
  gap: 8px;

  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background-color: white;

  &:focus-visible {
    outline: 3px solid ${Colors.MAIN_VARIANTS[60]};
    outline-offset: 2px;
  }

  ${(props) =>
    props.size == 'compact'
      ? css`
          padding: 8px 0;
          border: none;
          background: none !important;
        `
      : css`
          border-radius: 12px;
          padding: 16px;
          border: 2px solid ${Colors.NEUTRAL_VARIANTS[20]};
        `}

  ${(props) =>
    props.selected &&
    css`
      border-color: ${Colors.MAIN_VARIANTS[60]};
      background-color: ${Colors.MAIN_VARIANTS[10]};
    `}


  ${(props) =>
    props.disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.5;
    `}

    ${({ variant }) => {
    if (variant == 'vertical') {
      return `flex-direction: column;`;
    }
  }}
`;

export const Body = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const AddonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
